(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-quantity-tiers')) {
    customElements.define(
      'sb-quantity-tiers',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.enabled !== 'new') return;
          this.abort?.abort();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.addEventListener('input', () => this.update(), options);
          this.addEventListener('change', () => this.update(), options);
          this.addEventListener(
            'click',
            (event) => {
              if (!event.target.closest('[data-sbqt-add]')) return;
              const input = this.querySelector('.quantity__input');
              const state = this.getState(input);
              if (!state || !state.next || state.target > state.max) return;
              input.value = String(state.target);
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            },
            options
          );
          this.observer = new MutationObserver(() => this.update());
          this.observer.observe(this, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['min', 'max', 'step', 'value', 'disabled'],
          });
          this.update();
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
        }
        getState(input) {
          if (!input) return null;
          const quantity = Number(input.value);
          if (!Number.isFinite(quantity) || !Number.isInteger(quantity) || quantity < 1) return null;
          const min = Number(input.min || 1);
          const step = Math.max(1, Number(input.step) || 1);
          const max = input.max === '' ? Infinity : Number(input.max);
          const tiers = [
            { quantity: 5, percent: 15 },
            { quantity: 10, percent: 20 },
            { quantity: 20, percent: 35 },
            { quantity: 40, percent: 50 },
          ];
          const current = tiers.filter((tier) => quantity >= tier.quantity).at(-1);
          const next = tiers.find((tier) => quantity < tier.quantity);
          const target = next ? min + Math.max(0, Math.ceil((next.quantity - min) / step)) * step : quantity;
          return { quantity, current, next, target, max, tiers, valid: input.checkValidity() && !input.disabled };
        }
        setText(element, value) {
          if (element && element.textContent !== value) element.textContent = value;
        }
        format(template, quantity, percent) {
          return template.replaceAll('[quantity]', String(quantity)).replaceAll('[percent]', String(percent));
        }
        update() {
          const state = this.getState(this.querySelector('.quantity__input'));
          const badge = this.querySelector('[data-sbqt-badge]');
          const offer = this.querySelector('[data-sbqt-offer]');
          const button = this.querySelector('[data-sbqt-add]');
          if (!badge || !offer || !button) return;
          const valid = state?.valid;
          badge.hidden = !valid || !state.current;
          offer.hidden = !valid;
          this.querySelectorAll('[data-sbqt-tier]').forEach((item) => {
            const reached = !!valid && state.quantity >= Number(item.dataset.sbqtTier);
            item.classList.toggle('is-reached', reached);
          });
          let progress = 0;
          if (valid && state.quantity >= 5) {
            const index = state.tiers.findLastIndex((tier) => state.quantity >= tier.quantity);
            progress =
              index === 3
                ? 1
                : (index +
                    (state.quantity - state.tiers[index].quantity) /
                      (state.tiers[index + 1].quantity - state.tiers[index].quantity)) /
                  3;
          }
          this.style.setProperty('--sbqt-progress', String(progress));
          if (!valid) return;
          const percent = state.current?.percent || 0;
          this.setText(badge, this.format(this.dataset.badge, 0, percent));
          const blocked = !!state.next && state.target > state.max;
          button.hidden = !state.next || blocked;
          const difference = state.target - state.quantity;
          const targetTier = state.tiers.filter((tier) => state.target >= tier.quantity).at(-1);
          const message = !state.next
            ? this.dataset.max
            : blocked
            ? this.dataset.limit
            : this.format(this.dataset.more, difference, targetTier.percent);
          this.setText(this.querySelector('[data-sbqt-message]'), message);
          this.setText(button, this.format(this.dataset.add, difference, targetTier?.percent || percent));
          this.setText(
            this.querySelector('[data-sbqt-status]'),
            `${state.current ? this.format(this.dataset.badge, 0, percent) + '. ' : ''}${message}`
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
